export default "__VITE_ASSET__DeeWyiJa__"